// Re-exported from the shared @workspace/ui memory components (tdd-0042).
export { PrivateInfoDialog } from "@workspace/ui/components/memory";
